import { createAction } from '@reduxjs/toolkit'

import { SearchFilters } from '@pages/layout-view/types'

import { UserProfile } from 'types/auth'

export const pageSettingsLoaded = createAction<
  { pageSettings: { [pageID: string]: SearchFilters }; user?: UserProfile | null } | undefined
>('@PAGE_SETTINGS/load')
